import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { DOWNLOAD_BLOB_FILE } from '../queries/GetBlobFiles';

const DownloadBlobFile = async ({ queryKey }) => {
  const [, { fileName, token, departmentsFolder, departmentFolder, item, containerName, isProfileImage, setToast}] = queryKey;

  if (!token ) throw new Error('token not available');

  const downloadUrl = `/download/blob?&fileName=${encodeURIComponent(fileName)}&departmentsFolder=${encodeURIComponent(departmentsFolder)}&departmentFolder=${encodeURIComponent(departmentFolder)}&orderNumFolder=${encodeURIComponent(item.so)}&containerName=${encodeURIComponent(containerName)}&isProfileImage=${encodeURIComponent(isProfileImage)}`;
  try {
    const response = await axios.get(downloadUrl, {
      headers: {
        Authorization: token,
      },
      responseType: 'blob',
    });
    if(isProfileImage) return response;
    else return response.data;
  } catch (error) {
    if (error.response) {
      let errorMessage
      if (error.response) {

        const status = error.response.status;
        const errorMessages = {
          401: 'Expired Token',
          500: 'The file does not exist on the blob storage'
        };

        errorMessage = errorMessages[status] || 'An error occurred';
      }
      setToast({ showToast: true, message: errorMessage, type: 'error' });    } 
  }
};

export const useDownloadBlobFile = (params ) => {
  return useQuery({
    queryKey: [DOWNLOAD_BLOB_FILE, params ],
    queryFn: DownloadBlobFile,
    enabled: !!params.token && params.enabled,
    retry: false,
  });
};

